export default __webpack_public_path__ + "static/media/049-swimming pool.2adbe184.svg";